import Logo from './Logo';
import { SITE_NAME } from '../config/site';

/**
 * Footer for signed-in players. Deliberately slim so it stays out of the way
 * of the game screen.
 */
function Footer() {
  return (
    <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 py-6">
      <div className="mx-auto max-w-7xl px-6 lg:px-8 flex items-center justify-center gap-3">
        <Logo size={24} />
        <p className="text-sm text-gray-600 dark:text-gray-400">
          &copy;
          {' '}
          {new Date().getFullYear()}
          {' '}
          {SITE_NAME}
        </p>
      </div>
    </footer>
  );
}

export default Footer;
